import { LabeledValue_Root } from 'emerald-ui';
import { gray0, headerAccent } from 'emerald-ui/dist/globals/colors';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const DataHeaderRow_Root = styled.div`
    border-bottom: 1px solid ${gray0};
    background: ${headerAccent};
    ${theme.breakpoints.up('sm')} {
        & > dl {
            display: inline-flex;
        }
    }

    ${LabeledValue_Root} {
        border-right: 1px solid ${gray0};
        font-size: 1.25rem; /* 20px */
        padding: .75em 1em;
        flex-basis: 262px;
        min-width: 262px;

        &[data-type='Delivery Location'] {
            flex-grow: 1;
        }
    }

    ${theme.breakpoints.only('xs')} {
        width: 100%;
        & > div {
            flex-wrap: wrap;
            width: 100%;
        }

        ${LabeledValue_Root} {
            border: 0;
            font-size: 1.125rem;
            flex-grow: 1;
            padding: 1rem;
            &[data-type='Current Status'] {
                min-width: 100%;
                font-size: 1.375rem; /* 22px */
                padding-bottom: 0;
            }
        }
    }
`;
